import {Component, inject, OnInit, ViewChild} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterLink} from '@angular/router';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {SpinnerComponent} from '@shared/components/spinner/spinner.component';
import {BreadcrumbService} from '@cdss/services/breadcrumb.service';
import {PatientsService} from '@shared/api/services/v2/patients.service';
import {PatientBasic, PatientStatusEnum} from '@shared/api/models/query/patient.model';
import {OrderType, Pagination, PaginationResponse} from '@models/pagination.model';

@Component({
    selector: 'cdss-draft-patients-page',
    standalone: true,
    imports: [CommonModule, NgxDatatableModule, SpinnerComponent, RouterLink],
    templateUrl: './draft-patients.page.html',
})
export class DraftPatientsPage implements OnInit {
    @ViewChild('table') table: any;

    loading = false;
    rows: PatientBasic[] = [];
    pagination = new Pagination();

    private readonly patientsService = inject(PatientsService);
    private readonly breadcrumbService = inject(BreadcrumbService);

    ngOnInit(): void {
        this.breadcrumbService.set([{title: 'Draft patients', url: null}]);
        this.pagination.filter = {status: PatientStatusEnum.DRAFT};
        this.pagination.sort = {prop: 'createdAt', order: OrderType.DESC};
        this.loadRows();
    }

    setPage(pageInfo: {offset: number}): void {
        this.pagination.start = pageInfo.offset;
        if (this.table) this.table.offset = this.pagination.start;
        this.loadRows();
    }

    getTypeLabel(patient: PatientBasic): string {
        if (patient.carer == null) {
            return 'Patient only';
        }
        if (patient.user.phoneNumber == null) {
            return 'Carer only';
        }
        return 'Patient and carer';
    }

    getFeatureSetLabel(patient: PatientBasic): string {
        return patient.user?.activeLicense?.license?.name ?? '-';
    }

    private loadRows(): void {
        this.loading = true;
        this.patientsService.listPaginated(this.pagination).subscribe({
            next: (response: PaginationResponse<PatientBasic>) => {
                this.rows = response?.data ?? [];
                this.pagination.totalCount = response?.pagination?.totalCount ?? 0;
                this.loading = false;
            },
            error: () => {
                this.rows = [];
                this.loading = false;
            }
        });
    }
}
